// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".phone-input .q-field__control{width:100%!important}.phone-input .q-field__native{text-align:center!important;margin-left:-5px}.login-code-input .q-field__native{text-align:center!important}.login-code-input .q-field__control{width:65%!important}.header-wrapper{display:flex;justify-content:center;margin-top:30px;align-items:center}.logo-wrapper{width:15%}@media (max-width:769px){.logo-wrapper{width:35%}}", ""]);
// Exports
module.exports = exports;
